(() => {

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire800c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire800c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("erdIn", function(module, exports) {
const mainDescriptionColumn = document.querySelector(".collection__columbs-item");
if (!mainDescriptionColumn) return;
let secondDescriptionColumn;
const contentChildren = mainDescriptionColumn.children;
const halfThreshold = (mainDescriptionColumn.offsetHeight + 70) / 2;
let passedHalf = false;
let split = false;
for (const childNode of contentChildren){
    if (!split) passedHalf = childNode.offsetTop - mainDescriptionColumn.offsetTop + childNode.offsetHeight > halfThreshold;
    if (!split && passedHalf && childNode.tagName.toLowerCase() === "h3") {
        const breakingPoint = childNode.outerHTML.replace(/(<h3>)/, '</div><div class="collection__columbs-item"><h3>');
        mainDescriptionColumn.outerHTML = mainDescriptionColumn.outerHTML.replace(childNode.outerHTML, breakingPoint);
        break;
    }
}

});

document.addEventListener("click", (e)=>{
    if (e.target.classList.contains("js-dropdownBtn")) {
        const trigger = e.target;
        const target = trigger.parentElement.querySelector(".js-dropdown");
        if (trigger && target) {
            trigger.classList.toggle("is-open");
            target.classList.toggle("is-open");
        }
    }
});


const $cfc5570d9e242b22$var$storeBreadcrumbData = ()=>{
    let isSubCollection;
    const breadcrumbData = JSON.parse(sessionStorage.getItem("breadcrumbs")) || [];
    if (window.theme.template.name === "collection") {
        const lastSubCollectionsJSON = JSON.parse(sessionStorage.getItem("subCollections")) || [];
        isSubCollection = lastSubCollectionsJSON.some((item)=>item.url === window.theme.template.url);
    } else if (window.theme.template.name === "product") {
        const collectionsData = breadcrumbData.filter((item)=>item.name === "collection");
        if (collectionsData.length > 0) {
            const lastCollectionUrl = collectionsData[collectionsData.length - 1].url;
            const productCollections = theme.template.collections;
            if (productCollections.length > 0) isSubCollection = productCollections.some((item)=>item.url === lastCollectionUrl);
        }
    }
    const currentBreadcrumb = {
        title: window.theme.template.title,
        url: window.theme.template.url,
        name: window.theme.template.name
    };
    const existingBreadcrumbIndex = breadcrumbData.findIndex((crumb)=>crumb.url === currentBreadcrumb.url);
    if (existingBreadcrumbIndex !== -1) breadcrumbData.splice(existingBreadcrumbIndex);
    else if (isSubCollection) {
        if (breadcrumbData.length > 0) {
            if (breadcrumbData[breadcrumbData.length - 1].name === "product") breadcrumbData.splice(breadcrumbData.length - 1);
        }
    } else breadcrumbData.splice(0);
    breadcrumbData.push(currentBreadcrumb);
    sessionStorage.setItem("breadcrumbs", JSON.stringify(breadcrumbData));
    // Set sessionStorage with subcollections
    if (window.theme.template.name === "collection") {
        const subCollectionsEL = document.getElementById(`SubCollectionsJSON-${window.theme.template.id}`);
        if (subCollectionsEL) {
            const subCollections = subCollectionsEL.textContent;
            sessionStorage.setItem("subCollections", subCollections);
        } else sessionStorage.removeItem("subCollections");
    }
};
const $cfc5570d9e242b22$var$renderBreadcrumbs = ()=>{
    const maxBreadcrumbs = 4;
    let breadcrumbData = sessionStorage.getItem("breadcrumbs");
    if (breadcrumbData) {
        breadcrumbData = JSON.parse(breadcrumbData);
        const breadcrumbList = document.querySelector(".breadcrumb__list");
        if (breadcrumbList) breadcrumbList.innerHTML = "";
        // only render last maxBreadcrumbs
        const lastFourBreadcrumbData = breadcrumbData.slice(0 - maxBreadcrumbs);
        lastFourBreadcrumbData.forEach((crumb, index)=>{
            const listItem = document.createElement("li");
            listItem.className = `breadcrumb__item ${index === breadcrumbData.length - 1 ? "breadcrumb__item--active" : ""}`;
            if (index === breadcrumbData.length - 1) listItem.innerHTML = `<span>${crumb.title}</span>`;
            else listItem.innerHTML = `<a href="${crumb.url}">${crumb.title}</a>`;
            if (breadcrumbList) breadcrumbList.appendChild(listItem);
        });
    }
};
if (window.theme.template.name === "product" || window.theme.template.name === "collection") $cfc5570d9e242b22$var$storeBreadcrumbData();
document.addEventListener("DOMContentLoaded", $cfc5570d9e242b22$var$renderBreadcrumbs);


parcelRequire("erdIn");

})();
//# sourceMappingURL=parcel_scripts.js.map
